<h1>Edit Category</h1>

<ng-container *ngIf="category; else loadingOrError">
  <form [formGroup]="editCategoryForm" (ngSubmit)="saveCategory()">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput
             aria-label="Category Name"
             type="text"
             formControlName="name" />
      <mat-hint>The name is how it appears throughout your site.</mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Slug</mat-label>
      <input matInput aria-label="Category Slug" type="text" formControlName="slug" />
      <mat-hint>You <strong>can not</strong> change this!</mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Description</mat-label>
      <textarea matInput type="text" aria-label="Category Description" formControlName="description"></textarea>
      <mat-hint>The description is not required, however,
        some times it may be shown throughout your site if set.</mat-hint>
    </mat-form-field>

    <mat-checkbox formControlName="featured">Featured</mat-checkbox>

    <p [style.text-align]="'center'">
      <button
        mat-raised-button
        type="submit"
        color="accent"
        [disabled]="editCategoryForm.invalid">Save</button>
      <button
        mat-stroked-button
        type="button"
        color="warn"
        (click)="deleteCategory()">Delete</button>
    </p>
  </form>
</ng-container>

<ng-template #loadingOrError>
 <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
